import defaultSettings from '@/settings'
const { themeType } = defaultSettings

const state = {
  type: themeType
}

const mutations = {
  SET_THEME_TYPE: (state, type) => {
    state.type = type
    localStorage.setItem('themeType', type)
  },
}

const actions = {
  // 切换主题
  changeTheme({ commit }, theme) {
    return new Promise((resolve, reject) => {
      console.log('theme');
      console.log(theme);
      commit('SET_THEME_TYPE', theme.type)
      resolve()
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/theme.js